module.exports = __webpack_public_path__ + "static/img/shui_jkfa_icon.png";